// eslint-disable-next-line import/prefer-default-export
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const SET_IMAGE_POSITION = 'SET_IMAGE_POSITION'
